export default function scrollToTop() {
  // eslint-disable-next-line no-unused-expressions
  document.querySelector('.dashboard-inner-wrapper')?.scrollTo?.(0, 0);
}
